import React from 'react';
import UpdateBankComponent from './update-bank.component';

export default function UpdateBank() {
    return <UpdateBankComponent />;
}
